import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import SendPaymentLinks from "../../../presentation/modules/inbox/PaymentLinks/SendPaymentLinks";
import { sharingInformationService } from "../../../services/sharingInformationService";

const RxJOrderPaymentLink = ({ className }) => {
  const [showPaymentLinks, setShowPaymentLinks] = useState(false);
  const [originData, setOriginData] = useState({});
  const selectedId = useSelector((state) => state.conversationsReducer.selectedConversationId);
  const lastSelectedIdRef = useRef(selectedId);

  useEffect(() => {
    const subscription$ = sharingInformationService.getSubject();

    const myObservable = subscription$.subscribe((data) => {
      if ('openSendPaymentLinks' in data) {
        setShowPaymentLinks(data.openSendPaymentLinks);
        setOriginData(data.payload || {});
      }
      // Cerrar payment links cuando se abre el PDF modal
      if ('closePaymentLinksForPdf' in data && data.closePaymentLinksForPdf) {
        setShowPaymentLinks(false);
      }
    });

    return () => {
      myObservable.unsubscribe();
    };
  }, []);

  useEffect(() => {
    sharingInformationService.setSubject({ showSendPaymentLinks: showPaymentLinks });
    sharingInformationService.setSubject({});
    // Cerrar el PDF modal cuando se abre payment links
    if (showPaymentLinks) {
      sharingInformationService.setSubject({
        closePdfModal: true,
        closeProductSelection: true,
        closeFastAnswersSelection: true
      });
      sharingInformationService.setSubject({});
    }
  }, [showPaymentLinks]);

  // Cerrar el modal si cambia la conversación seleccionada mientras está abierto
  useEffect(() => {
    if (!showPaymentLinks) {
      lastSelectedIdRef.current = selectedId;
      return;
    }

    if (lastSelectedIdRef.current == null) {
      lastSelectedIdRef.current = selectedId;
      return;
    }

    if (selectedId !== lastSelectedIdRef.current) {
      setShowPaymentLinks(false);
      setOriginData({});
    }
  }, [selectedId, showPaymentLinks]);

  const onClose = () => {
    setShowPaymentLinks(false);
    setOriginData({});
  };

  const onSendPaymentLink = (text) => {
    sharingInformationService.setSubject({
      fillInputChatComponent: true,
      sendPaymentLinks: true,
      text
    });
    sharingInformationService.setSubject({});
    setShowPaymentLinks(false);
  };

  // No renderizar si showPaymentLinks es false o si no hay order
  if (!showPaymentLinks || !originData.order) {
    return null;
  }

  return (
    showPaymentLinks ? (
      <SendPaymentLinks
        order={originData.order}
        onClose={onClose}
        onSendPaymentLink={onSendPaymentLink}
        platform={originData.platform}
        className={className}
      />
    ) : null
  );
};

export default RxJOrderPaymentLink;
